import { PiX } from "react-icons/pi";

export const CrossIcon = () => <PiX className="text-xl md:text-2xl" />;
